module.exports = __webpack_public_path__ + "img/1557089224.a6254b57.jpg";